"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChartBar = function ChartBar() {
  return _react2.default.createElement(
    "g",
    { id: "chart-bar" },
    _react2.default.createElement("path", {
      d: "M444.428571,0 L55.5,0 C24.89699,0.117479262 0.117479262,24.89699 0,55.5 L0,444.428571 C0.0783148516,475.059472 24.8692252,499.882289 55.5,500 L444.428571,500 C475.087244,499.921488 499.921488,475.087244 500,444.428571 L500,55.5 C499.882289,24.8692252 475.059472,0.0783148516 444.428571,1.01506105e-12 L444.428571,0 Z M166.642857,388.964286 L111.071429,388.964286 L111.071429,194.464286 L166.642857,194.464286 L166.642857,388.964286 L166.642857,388.964286 Z M277.75,388.964286 L222.178571,388.964286 L222.178571,111.071429 L277.75,111.071429 L277.75,388.892857 L277.75,388.964286 Z M388.892857,388.964286 L333.321429,388.964286 L333.321429,277.821429 L388.892857,277.821429 L388.892857,388.964286 Z",
      id: "Shape"
    })
  );
};

exports.default = ChartBar;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/ChartBar.js
// module id = 2932
// module chunks = 4